var React = require('react');

function CoverSquare (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Trazado_47","data-name":"Trazado 47","d":"M831.5,913.994c0-2.675-.086-5.336-.243-8.3.129-2.661.243-5.351.243-8.041,0-68.382.172-351.588.172-351.588l-.415-39.332H607.195c0,113.777,1.275,615.962,1.275,615.962h223.2Zm-45.066-6.9c.157,2.5.229,4.692.229,6.9v163.868H674.928c-.261-135.662,5.349-531.794,5.349-531.794H786.662V897.656c0,2.361-.115,4.707-.243,7.024l-.057,1.2Z","transform":"translate(-607.195 -506.736)","fill":"#db1a16"}));
}

CoverSquare.defaultProps = {"width":"224.475","height":"615.962","viewBox":"0 0 224.475 615.962"};

module.exports = CoverSquare;

CoverSquare.default = CoverSquare;
